<template>
  <div class="finance">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs :crm_id="this.$route.params.crmid"/>
          <div v-if="formData.id || loading" class="table-agile-info" v-loading="loading">
            <template v-if="$route.params.orderId">
              <el-alert
                v-if="formData.commission_status < 2"
                show-icon
                title="该订单需要外联老师进行审核确认后生效，请及时联系。"
                type="warning" />
              <el-alert
                v-if="formData.commission_status > 2"
                show-icon
                :title="formData.commission_status === 3 ? '该订单已被外联老师审核通过，修改后需重新审核。' : '该订单已经自动通过佣金审核。'"
                type="success" />
            </template>
            <div class="common-new-title mode2">
              <span>芥末订单信息</span>
              <div class="custom-area">
                <el-tooltip
                  placement="right"
                  effect="dark">
                  <div slot="content">
                    <ul>
                      <li> 请通过钉钉提交“订单修改申请”。</li>
                      <li> 申请时请详细标示出想要修改的数据字段，做截图说明。</li>
                      <li> &nbsp;
                        <br>1、财务数据分为“订单”和“报账”两个部分。除了极少数特别情况，系统不会替代老师修改数据。
                        <br>2、对于报账的问题，系统会回滚到“拒绝”状态，老师可自行修改并提交财务审核。
                        <br>3、对于订单的问题，因数据计算有依赖关系，系统会撤销相关报账；老师可自行修改订单后重新报账。
                        <br>4、如果发现问题请尽早提交申请修改，以避免导致核算错误。
                      </li>
                    </ul>
                  </div>
                  <span style="color: blue"> <i class="el-icon-question blue"/> 如何修改订单/报账中的问题？</span>
                </el-tooltip>
              </div>
            </div>
            <div class="info-manag-wrap">
              <div class="box-content">
                <label class="form-tit">订单编号:</label>
                <span>{{ formData.order_no || '自动生成' }}</span>
              </div>
              <div class="box-content">
                <label class="form-tit">学生姓名:</label>
                <span>{{ pageDs.custom_name }}</span>
              </div>
              <div class="box-content">
                <label class="form-tit">入学时间:</label>
                <span>{{ pageDs.custom_year }}</span>
              </div>
              <div class="box-content">
                <label class="form-tit">办理国家:</label>
                <span>{{ pageDs.active_country }}</span>
              </div>
              <div class="box-content">
                <label class="form-tit"><i style="color: red">*</i>发起人:</label>
                <span>{{ formData.teacher_name }}</span>
              </div>
              <div class="box-content">
                <label class="form-tit"><i style="color: red">*</i>所属部门:</label>
                <span>{{ formData.dep_name }}</span>
              </div>
              <div class="box-content">
                <label class="form-tit">加项订单:</label>
                <span>{{ formData.is_plus_str }}</span>
              </div>
              <div class="box-content">
                <label class="form-tit"><i style="color: red">*</i>新单/补尾款:</label>
                <span>{{ formData.is_renewal_str }}</span>
              </div>
              <div class="box-content box-content-span">
                <label class="form-tit"><i style="color: red">*</i>订单名称:</label>
                <span>{{ formData.order_title }}</span>
              </div>
              <div class="box-content box-content-span">
                <label class="form-tit">所申学校:</label>
                <el-tag v-for="item in formData.apply_school_list" :key="item.sh_id">{{ item.sh_name_cn }}</el-tag>
              </div>
              <div class="box-content box-content-span">
                <label class="form-tit">订单备注:</label>
                <span>{{ formData.order_memo }}</span>
              </div>
            </div>
            <!--列表部分 start -->
            <div class="common-new-title mode2">
              <span>商品列表</span>
            </div>
            <el-table
              ref="goodTable"
              :data="formData.goods_list">
              <el-table-column
                prop="goods_id"
                label="商品编号">
              </el-table-column>
              <el-table-column
                prop="goods_title"
                label="商品名称">
              </el-table-column>
              <el-table-column
                prop="srv_fullcase_str"
                label="产品类目">
              </el-table-column>
              <el-table-column
                prop="deposit_fee"
                label="押金">
                <template slot-scope="scope">
                  <div>
                    <span>{{ scope.row.deposit_fee }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="signup_fee"
                label="报名费">
                <template slot-scope="scope">
                  <div>
                    <span>{{ scope.row.signup_fee }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="service_fee"
                label="服务费">
                <template slot-scope="scope">
                  <div>
                    <span>{{ scope.row.service_fee }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="need_fee"
                label="应付金额">
                <template slot-scope="scope">
                  <div>
                    {{ Number(scope.row.deposit_fee) + Number(scope.row.signup_fee) + Number(scope.row.service_fee) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="showCommission"
                prop="commission_fee"
                label="佣金参考">
                <template slot-scope="scope">
                  <div>
                    <span>{{ scope.row.commission_fee }}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <!--列表部分 end-->
            <div class="table-agile-info" style="color:#aaa">
              <p>说明：① 应付金额 = 押金 + 报名费 + 服务费
                <template v-if="showCommission">
                  &nbsp; ② 合同额 / 预付账款 / 销售额 = 服务费 + 佣金
                </template>
              </p>
            </div>
            <div class="table-agile-info">
              <div class="box-content" v-if="showCommission">
                <label class="form-tit">合同额（含佣金）:</label>
                <span>{{ formData.pre_fee }}</span>
              </div>
              <div class="box-content">
                <label class="form-tit">应付总额:</label>
                <span>{{ formData.need_fee }} <font color="#999">（已付:  {{ formData.paid_fee }}）</font></span>
              </div>
              <div class="box-content">
                <label class="form-tit">押金总额:</label>
                <span>{{ formData.deposit_fee }}</span>
              </div>

              <div class="box-content" v-if="!showCommission"/>
              <div class="box-content">
                <label class="form-tit">订单首款:</label>
                <span>{{ formData.first_fee }}</span>
              </div>
              <div class="box-content">
                <label class="form-tit">缴费截止日期:</label>
                <span>{{ formData.last_payment_date }}</span>
              </div>
            </div>
            <!--列表部分 start -->
            <div class="common-new-title mode2">
              <span>支付记录</span>
              <div class="custom-area" v-if="$hasPermission(1) || !showCommission" v-show="formData.commission_status > 2">
                <el-button type="primary" size="small" icon="el-icon-tickets" @click="openAccountDialog(1)">发起报账</el-button>
              </div>
            </div>
            <jm-tableList
              v-show="Number(formData.commission_status) > 2"
              :url="getListurl"
              :search-data="searchData"
            >
              <el-table-column
                slot="total_amount"
                slot-scope="scope"
                v-bind="scope.attrs"
                :label="scope.label"
              >
                <template slot-scope="props">
                  <p>
                    <span>{{ Number(props.row.total_amount) }}</span>
                    <span v-if="Number(props.row.real_amount)">({{ Number(props.row.real_amount) }}{{ props.row.currency_type_str }})</span>
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                slot="order_no"
                slot-scope="scope"
                v-bind="scope.attrs"
                :label="scope.label">
                <template slot-scope="props">
                  <el-popover
                    placement="top"
                    width="200"
                    trigger="hover">
                    {{ props.row.order_no }}
                    <span slot="reference" class="white-nowrap">{{ props.row.order_no }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                slot="memo"
                slot-scope="scope"
                v-bind="scope.attrs"
                :label="scope.label">
                <template slot-scope="props">
                  <el-popover
                    placement="top"
                    width="200"
                    trigger="hover">
                    {{ props.row.memo }}
                    <span slot="reference" class="white-nowrap">{{ props.row.memo }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                slot="finance_message"
                slot-scope="scope"
                v-bind="scope.attrs"
                :label="scope.label">
                <template slot-scope="props">
                  <el-popover
                    placement="top"
                    width="200"
                    trigger="hover">
                    {{ props.row.finance_message }}
                    <span slot="reference" class="white-nowrap">{{ props.row.finance_message }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                slot="lastColumn"
                fixed="right"
                align="center"
                header-align="center"
                width="150"
                label="操作">
                <template slot-scope="scope">
                  <el-button
                    v-if="Number(scope.row.finance_status) !== 3 && Number(scope.row.finance_status) !== 1 && (scope.row.pub_teacherid === userInfo.userid || $hasPermission([]))"
                    size="small"
                    type="success"
                    @click="openAccountDialog(2, scope.row)">修改报账
                  </el-button>
                  <el-button
                    v-if="$hasPermission([173]) || userInfo.userid === 2243703"
                    type="primary"
                    @click="openSpecialDialog(scope.row)"
                    size="small">报账文本
                  </el-button>
                </template>
              </el-table-column>
            </jm-tableList>
            <!--列表部分 end-->
          </div>
          <jm-empty v-else :description="loading? '正在加载中 ...' : '订单数据不存在或者已删除'" />
          <!--报账弹窗 start-->
          <el-dialog
            :title="accountDialogTitle"
            :visible="accountDialogLock"
            width="550px"
            :show-close="false">
            <el-form label-width="120px">
              <el-row>
                <el-col :span="24">
                  <el-form-item :label="Number(accountDialogForm.payment_method) === 14 ? '*淘宝订单号：' : '交易流水编号：'">
                    <el-input v-model="accountDialogForm.transaction_id" class="jm-input280" :disabled="accountDialogForm.disabled" />
                  </el-form-item>
                  <el-form-item label="*支付方式：">
                    <el-select
                      @change="changePaymentMethod"
                      v-model="accountDialogForm.payment_method"
                      class="jm-input280"
                      placeholder="请选择"
                      :disabled="accountDialogForm.disabled">
                      <el-option
                        v-for="item in pageDs.payment_method"
                        :key="item.id"
                        :label="item.value"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="*付款时间：">
                    <el-date-picker
                      :disabled="accountDialogForm.disabled"
                      class="jm-input280"
                      v-model="accountDialogForm.paid_time"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="datetime"
                      placeholder="选择日期时间">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="支付币种：">
                    <el-select v-model="accountDialogForm.currency_type" class="jm-input280" placeholder="请选择" :disabled="accountDialogForm.disabled">
                      <el-option
                        v-for="item in pageDs.currency_type"
                        :key="item.id"
                        :label="item.value"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-show="accountDialogForm.currency_type !== '1'" label="缴费外币金额：">
                    <el-input-number v-model="accountDialogForm.real_amount" class="jm-input280" :disabled="noNeedPay || accountDialogForm.disabled" />
                  </el-form-item>
                  <el-form-item label="*缴费金额：">
                    <el-input-number v-model="accountDialogForm.total_amount" class="jm-input280" :disabled="noNeedPay || accountDialogForm.disabled" />
                  </el-form-item>
                  <el-form-item label="销售备注：">
                    <el-input v-model="accountDialogForm.memo" type="textarea" resize="none" class="jm-input280"/>
                  </el-form-item>
                  <el-from-item>
                    <el-alert
                      show-icon
                      :closable="false"
                      title="0元支付报账后，单击“提交”将自动确认，否则无法进行下次报账"
                      v-if="noNeedPay" />
                  </el-from-item>
                </el-col>
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="info" @click="dialogClose(1)">取 消</el-button>
              <el-button type="primary" :loading="btnLoading" @click="accountSave(1)">保 存</el-button>
              <el-button type="success" :loading="btnLoading" @click="accountSave(2)">提 交</el-button>
            </span>
          </el-dialog>
          <!--报账弹窗 end-->

          <!--报账文本弹窗 start-->
          <el-dialog
            title="报账内容"
            :visible.sync="specialDialogLock"
            width="600px"
            :show-close="false">
            <el-input
              type="textarea"
              v-model="specialText"
              autosize
              :read-only="true" />
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" :loading="btnLoading" @click="specialDialogLock = false">确 定</el-button>
            </span>
          </el-dialog>
          <!--报账文本弹窗 end-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import empty from '@/components/common/empty';
import tableList from '@/components/data/tableList';
import { formatSelectGroupData } from '@/utils/utils.js';
import schoolMultipleSearch from '@/components/tool/select/schoolMultipleSearch';

function getDefaultAccount() {
  return {
    transaction_id: '',
    pub_userid: '',
    big_order_id: '',
    total_amount: '',
    currency_type: '1',
    real_amount: '',
    payment_method: '',
    paid_time: '',
    memo: '',
    fapiao: '',
    submit: 1,
  };
}

export default {
  data() {
    return {
      loading: true,
      formData: {
        id: 0,
        create_uid: '',
        teacher_name: '',
        apply_school_ids: '',
        is_plus: 2143,
        goods_list: [],
        order_memo: ''
      },
      pageDs: {},
      searchData: {
        isOrderDetail: true,
        big_order_id: this.$route.params.orderId,
        project_id: 12
      },
      accountDialogTitle: '发起报账',
      accountDialogLock: false,
      accountDialogForm: getDefaultAccount(),
      getListurl: '/index/jm.trade2022/orderList',
      btnLoading: false,
      userInfo: {},
      specialDialogLock: false,
      specialText: ''
    };
  },
  computed: {
    id () {
      if (this.$route.params === undefined) {
        return false;
      }
      return this.$route.params.id;
    },
    // 是否展示芥末佣金参考
    showCommission () {
      return this.$hasPermission([
        173, // 外联人员
        33, // 日本主管
        121, // 英美主管
        148, // 欧亚主管(日韩)
        22, // 韩国主管
        96, // 英美文书主管
        122, // 英美咨询主管
        101, // 日本咨询主管
        173, // 外联人员
        39, // 前程日本主管
        51, // 前程日本咨询主管
        81, // 运营质检
        62, // 运营监管
        171, // 财务报账审核
        4, // 财务总监
      ]);
    },
    // 只读类主管
    readOnlyManager () {
      return this.$hasPermission([
        33, // 日本主管
        121, // 英美主管
        148, // 欧亚主管(日韩)
        22, // 韩国主管
        96, // 英美文书主管
        122, // 英美咨询主管
        101, // 日本咨询主管
        39, // 前程日本主管
        51, // 前程日本咨询主管
      ], true);
    },
    // 无需支付
    noNeedPay() {
      return Number(this.accountDialogForm.payment_method) === 33;
    }
  },
  methods: {
    // 关闭弹窗
    dialogClose(check) {
      switch (check) {
        case 1:
          this.accountDialogLock = false;
          break;
        case 2:
          this.goodDialogLock = false;
          break;
        default:
          break;
      }
    },
    // 报账数据初始化
    openAccountDialog(val, row = null) {
      switch (val) {
        case 1: // 发起报账
          this.accountDialogTitle = '发起报账';
          this.accountDialogForm = getDefaultAccount();
          this.accountDialogForm.pub_userid = this.formData.crm_id;
          this.accountDialogForm.big_order_id = this.formData.id;
          this.accountDialogForm.dep_id = this.formData.dep_id;
          this.accountDialogForm.disabled = false;
          break;
        case 2: // 修改报账
          this.accountDialogTitle = '修改报账';
          this.accountDialogForm = Object.assign({}, this.accountDialogForm, row);
          this.accountDialogForm.disabled = this.accountDialogForm.trade_type === 'ONLINE_PAID';
          break;
        default:
          break;
      }
      this.accountDialogLock = true;
    },
    // 打开报账文本弹窗
    openSpecialDialog(row) {
      this.specialDialogLock = true;
      this.specialText = row.special_text;
    },
    // 支付方式
    changePaymentMethod(method) {
      if (Number(method) === 33) {
        this.accountDialogForm.real_amount = 0;
        this.accountDialogForm.total_amount = 0;
      }
    },
    // 保存报账数据
    accountSave(val) {
      if (Number(this.accountDialogForm.payment_method) === 14 && !this.accountDialogForm.transaction_id) {
        this.$message.error('天猫付款必须填写淘宝订单号');
        return false;
      }
      if (!this.accountDialogForm.payment_method) {
        this.$message.error('请选择支付方式');
        return false;
      }
      if (!this.accountDialogForm.paid_time) {
        this.$message.error('请填写付款时间');
        return false;
      }
      if (!this.noNeedPay && !this.accountDialogForm.total_amount) {
        this.$message.error('请填写缴费金额');
        return false;
      }
      this.btnLoading = true;
      switch (val) {
        case 1:
          this.accountDialogForm.submit = 0;
          break;
        case 2:
          this.accountDialogForm.submit = 1;
          break;
        default:
          break;
      }
      this.$http
        ._post({
          url: '/index/jm.trade2022/edit',
          data: this.accountDialogForm
        })
        .then(() => {
          this.dialogClose(1);
          this.$message.success(val === 1 ? '保存成功' : '提交成功，已提醒财务审核');
          this.$store.commit('updateRefresh', true);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 获取页面数据
    async getFormData(orderId) {
      const { data } = await this.$http
        ._post({
          url: '/index/jm.order2022/find',
          data: { id: orderId }
        });
      return data;
    },
    priceFormat(val) {
      if (val && val.indexOf(',') > -1) {
        let arr = val.split(',');
        if (arr[1] === '-1') {
          return `${arr[0]}起`;
        }
        return `${arr[0]}~${arr[1]}`;
      } else if (val === '-1') {
        return '金额不限';
      }
      return val;
    }
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList,
    'jm-empty': empty,
    schoolMultipleSearch
  },
  mounted() {
    this.formData.crm_id = this.$route.params.id;
    this.userInfo = this.$store.getters.userInfo;
    this.loading = true;
    this.$http
      ._post({
        url: '/index/jm.order2022/findSearchDs',
        data: { crm_id: this.$route.params.id, readonly: 1 }
      })
      .then(async (res) => {
        if (res.result >= 0) {
          this.pageDs = res.data;
          this.pageDs.create_list = formatSelectGroupData(res.data.create_list);
          if (Number(this.$route.params.orderId)) {
            this.formData = await this.getFormData(this.$route.params.orderId);
          }
        }
      })
      .catch(() => {
        setTimeout(() => {
          this.$router.push({ name: 'editStudent', params: { id: this.$route.params.id } });
        }, 1000);
      })
      .finally(() => {
        this.$http
          ._post({
            url: '/index/jm.trade2022/searchData'
          })
          .then(({ data }) => {
            this.pageDs = Object.assign({}, this.pageDs, data);
          })
          .finally(() => {
            this.loading = false;
          });
      });
  }
};
</script>
